import React from 'react'
import './radioCards.scss'

export interface RadioCardOption {
  value: string
  label: string
  description: string
  icon?: React.ReactNode
  enabled?: boolean
}

interface RadioCardsProps {
  options: RadioCardOption[]
  selectedValue: string
  onChange: (value: string) => void
  label?: string
}

const RadioCards: React.FC<RadioCardsProps> = ({
  options,
  selectedValue,
  onChange,
  label
}) => (
  <div className="radio-cards">
    {label && (
      <span className="radio-cards__label">
        {label.trimEnd().replace(/\*$/, '')}
        {label.endsWith('*') && (
          <span className="radio-cards__required"> *</span>
        )}
      </span>
    )}
    <div className="radio-cards__grid">
      {options.map((option) => {
        const isSelected = selectedValue === option.value
        const isDisabled = option.enabled === false
        return (
          <button
            key={option.value}
            type="button"
            className={`radio-cards__card${
              isSelected ? ' radio-cards__card--selected' : ''
            }${isDisabled ? ' radio-cards__card--disabled' : ''}`}
            disabled={isDisabled}
            onClick={() => onChange(option.value)}
          >
            <span className="radio-cards__radio">
              {isSelected && <span className="radio-cards__dot" />}
            </span>
            {option.icon && (
              <span className="radio-cards__icon-wrap">{option.icon}</span>
            )}
            <span className="radio-cards__title">{option.label}</span>
            <span className="radio-cards__description">
              {option.description}
            </span>
          </button>
        )
      })}
    </div>
  </div>
)

export default RadioCards
